import React, { Component } from 'react';
import { change } from 'redux-form';
import { Accordion, Icon, Header } from 'semantic-ui-react';
import { USER_ACCESS_ROLE_FORM } from 'Common/FormEnum';
import { checkAllInGroup } from '../state/actions';
import { Summary } from './Summary';
import { Checkbox } from './Checkbox';
import { GroupFunctions } from './GroupFunctions';
import {
  CHECKBOX_TYPE_ALLOWREAD,
  CHECKBOX_TYPE_ALLOWWRITE,
  CHECKBOX_TYPE_PREFERENCES,
  groupDisplayPreferences,
  groupDisplayReadOnly,
  extractPreferences,
} from '../helpers/';

export class GroupRoot extends Component {
  /**
   * According to an issue in github, redux forms
   * does not trigger a redraw on when using the
   * action `initialize`. In order to update a large
   * amount of fields at once, we need to use the `initialize`
   * function vs multiple change calls.
   *
   * https://github.com/erikras/redux-form/issues/3435
   */
  triggerReduxFormUpdate = () => {
    this.props.dispatch(
      change(
        USER_ACCESS_ROLE_FORM,
        'redraw',
        Math.floor(Math.random() * Math.floor(1000))
      )
    );
  };

  getPreferences = () => extractPreferences(this.props.group);

  render() {
    const {
      dispatch,
      title,
      group,
      formValues = {},
      icon,
      index,
      activeIndex,
      setActiveIndex,
    } = this.props;

    return (
      <React.Fragment>
        <Accordion.Title active={activeIndex === index} index={index}>
          <div className="group-root--top">
            <span
              onClick={() => {
                setActiveIndex(index);
              }}
            >
              <Icon name="dropdown" />
            </span>
            <Header
              as="h4"
              icon={icon}
              content={title}
              onClick={() => {
                setActiveIndex(index);
              }}
            />
            <Summary formValues={formValues} group={group} />
            <div className="group-root--master-checkboxes">
              <div className="group-root--master-checkbox">
                {groupDisplayReadOnly(group) && (
                  <React.Fragment>
                    <div>Read Only</div>
                    <Checkbox
                      group={group}
                      formValues={formValues}
                      type={CHECKBOX_TYPE_ALLOWREAD}
                      onClick={(e, { checked }) => {
                        dispatch(
                          checkAllInGroup(
                            group,
                            formValues,
                            CHECKBOX_TYPE_ALLOWREAD,
                            checked
                          )
                        );
                        this.triggerReduxFormUpdate();
                      }}
                    />
                  </React.Fragment>
                )}
              </div>
              <div className="group-root--master-checkbox">
                <div>Write</div>
                <Checkbox
                  group={group}
                  formValues={formValues}
                  type={CHECKBOX_TYPE_ALLOWWRITE}
                  onClick={(e, { checked }) => {
                    dispatch(
                      checkAllInGroup(
                        group,
                        formValues,
                        CHECKBOX_TYPE_ALLOWWRITE,
                        checked
                      )
                    );
                    this.triggerReduxFormUpdate();
                  }}
                />
              </div>
              <div className="group-root--master-checkbox">
                {groupDisplayPreferences(group) && (
                  <React.Fragment>
                    <div>Preferences</div>
                    <Checkbox
                      group={this.getPreferences()}
                      formValues={formValues}
                      type={CHECKBOX_TYPE_PREFERENCES}
                      onClick={(e, { checked }) => {
                        dispatch(
                          checkAllInGroup(
                            this.getPreferences(),
                            formValues,
                            CHECKBOX_TYPE_PREFERENCES,
                            checked
                          )
                        );
                        this.triggerReduxFormUpdate();
                      }}
                    />
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </Accordion.Title>
        <Accordion.Content active={activeIndex === index}>
          <GroupFunctions
            title={title}
            data={group}
            formValues={formValues}
            dispatch={dispatch}
            triggerReduxFormUpdate={this.triggerReduxFormUpdate}
          />
        </Accordion.Content>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/components/GroupRoot.js